<template>
  <div class="code-line education-block">
    <span class="code-comment">// Education</span>
    <div class="education-entries">
      <div
        v-for="item in education"
        :key="item.id"
        class="education-entry"
      >
        <span class="education-entry-text">
          <span class="code-keyword">{{ item.degree }}</span>
          <span class="education-meta">
            ({{ item.year }}) — {{ item.institution }}, {{ item.faculty }}
          </span>
        </span>
        <a
          v-if="item.link"
          :href="item.link"
          target="_blank"
          rel="noopener noreferrer"
          class="education-link"
        >
          <span class="education-link-prefix">→</span>
          <span class="education-link-text">
            <span class="code-keyword">link</span>:
            <span class="code-string">"{{ item.linkLabel || 'thesis' }}"</span>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { education } from '../stores/education';

export default {
  name: 'EducationBlock',
  data() {
    return {
      education,
    };
  },
};
</script>

<style scoped>
.education-block {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.education-entries {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.education-entry {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.education-entry-text {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem 0.5rem;
}

.education-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.85rem;
  border-radius: 4px;
  text-decoration: none;
  background-color: #1e1e1e;
  border: 1px solid #0078d4;
  flex-shrink: 0;
  transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.education-link:hover {
  background-color: #2a3a4a;
  border-color: #4ec9b0;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 120, 212, 0.25);
}

.education-link-prefix {
  color: #4ec9b0;
  font-size: 0.9rem;
}

.education-link-text {
  font-size: 0.85rem;
  white-space: nowrap;
}

.code-comment {
  color: #6a9955;
}

.code-keyword {
  color: #569cd6;
}

.education-meta {
  color: #ce9178;
}

.code-string {
  color: #ce9178;
}
</style>
